'use client'
import FaqsList from '@/components/faqs/FaqsList'
import { Category } from '@/sanity/lib/types'
import { useState } from 'react'

import FaqsCategories from '@/components/faqs/FaqsCategories'

export default function DesktopFAQLayout() {
  const [activeCategory, setActiveCategory] = useState<Category>('Companies')

  return (
    <div className="hidden gap-6 lg:flex lg:flex-row">
      <FaqsCategories
        openedCategory={activeCategory}
        setOpenedCategory={setActiveCategory}
      />
      <FaqsList key={String(activeCategory)} category={activeCategory} />
    </div>
  )
}
